import { createSlice } from "@reduxjs/toolkit";

const refundInitiationFilterSlice = createSlice({
  name: "refundInitiationFilter",
  initialState: {
    status: "",
    search: "",
  },
  reducers: {
    setRefundInitiationStatusFilter: (state, action) => {
      state.status = action.payload ?? null;
    },
    setRefundInitiationSearchFilter: (state, action) => {
      state.search = action.payload ?? null;
    },
    clearRefundInitiationSearchFilter: (state) => {
      state.search = null;
    },
  },
});

export const {
  setRefundInitiationStatusFilter,
  setRefundInitiationSearchFilter,
  clearRefundInitiationSearchFilter,
} = refundInitiationFilterSlice.actions;

// ✅ selector fixed
export const selectRefundInitiationState = (state) =>
  state.refundInitiationFilter;

export default refundInitiationFilterSlice.reducer;
